import { render, staticRenderFns } from "./NavUpdateLog.vue?vue&type=template&id=e649969e&scoped=true&"
import script from "./NavUpdateLog.vue?vue&type=script&lang=js&"
export * from "./NavUpdateLog.vue?vue&type=script&lang=js&"
import style0 from "./NavUpdateLog.vue?vue&type=style&index=0&id=e649969e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e649969e",
  null
  
)

export default component.exports